const optionsComponent = require('../optionsComponent/optionsComponent');

const selectMultiple = Object.assign({}, optionsComponent, {
    subelements: {
        selectAll: false,
        selectNone: false
    },
    // Handle returned by hm.behaviors.tags.create (getValues/selectAll/
    // selectNone). Generic name — the underlying widget is the tier's concern
    // (Tagify under metronic_8); base no longer references any tag library.
    tags: false,
    // Free-tagging mode (set from data-zit-free-tags). When true the user can type
    // arbitrary tags; when false (default) only whitelisted options are accepted.
    freeTags: false,

    init: function () {
        optionsComponent.init.call(this);

        this.selectedValue = String(this.selectedValue).split(',');

        this.options.forEach((option) => {
            if (typeof option.id === 'number') {
                option.id = option.id.toString();
            }
        });

        this.initTags();

        if (this.subelements.selectAll !== false) {
            this.subelements.selectAll.addEventListener('click', (e) => { e.preventDefault(); this.selectAll(); });
        }

        if (this.subelements.selectNone !== false) {
            this.subelements.selectNone.addEventListener('click', (e) => { e.preventDefault(); this.selectNone(); });
        }
    },

    initTags: function () {
        // Delegate the tag-widget construction to the theme's tags behaviour
        // (metronic_8 wraps Tagify; base ships a throwing stub). The adapter
        // owns the whitelist / transformTag / dropdown config and returns a
        // handle exposing getValues / selectAll / selectNone. The component
        // hands it only the option list + free-tagging flag — everything the
        // adapter needs to enforce (or not) the whitelist and resolve tag text.
        this.tags = this.hm.behaviors.tags.create(this.element, {
            options: this.options,
            freeTags: this.freeTags
        });
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        if (this.tags !== false) {
            // The adapter returns the current selection as an array of value strings.
            this.selectedValue = this.tags.getValues();
        }

        return this.selectedValue;
    },

    selectAll: function () {
        this.tags.selectAll();
    },

    selectNone: function () {
        this.tags.selectNone();
    }
});

module.exports = selectMultiple;